import { render, staticRenderFns } from "./MenuAssign.vue?vue&type=template&id=3fcc0e06"
import script from "./MenuAssign.vue?vue&type=script&lang=js"
export * from "./MenuAssign.vue?vue&type=script&lang=js"
import style0 from "./MenuAssign.vue?vue&type=style&index=0&id=3fcc0e06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports